export const SEARCH_TILE_SIZE_MIN = 96;
export const SEARCH_TILE_SIZE_DEFAULT = 224;
export const SEARCH_TILE_SIZE_MAX = 640;
export const SEARCH_TILE_SIZE_STEP = 32;
